module.exports = {"610725001":"勉阳街道","610725101":"武侯镇","610725102":"周家山镇","610725103":"同沟寺镇","610725105":"新街子镇","610725106":"老道寺镇","610725107":"褒城镇","610725109":"金泉镇","610725110":"定军山镇","610725111":"温泉镇","610725112":"元墩镇","610725113":"阜川镇","610725114":"新铺镇","610725116":"茶店镇","610725117":"镇川镇","610725118":"漆树坝镇","610725119":"张家河镇","610725120":"长沟河镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/610725.json
// module id = 2991
// module chunks = 0